<template>
  <div id="app">
    <Header></Header>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
html {
  overflow: "-moz-hidden-unscrollable";
  height: 100%;
  scroll-behavior: smooth;
}

body::-webkit-scrollbar {
  display: none;
}

::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

/* 兼容 Firefox */
* {
  scrollbar-width: none;
}

/* 兼容 IE */
* {
  -ms-overflow-style: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue